export default {
  agreement: 'components.views.sign-up-view.agreement',
  termsOfService: 'components.views.sign-up-view.agreement.terms-of-service',
  privacyPolicy: 'components.views.sign-up-view.agreement.privacy-policy'
}
